import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { LadleHeatMetricReducer } from "../reducers/LadleHeatMetricReducer";

const LadleHeatMetricContext = createContext({
	state: LadleHeatMetricReducer.getInitialState(),
	actions: LadleHeatMetricReducer.actions,
});

export const useLadleHMContext = () => useContext(LadleHeatMetricContext);

export const LadleHMProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: LadleHeatMetricReducer.getInitialState(),
		reducers: LadleHeatMetricReducer.caseReducers,
	});
	return (
		<LadleHeatMetricContext.Provider value={{ state, actions }}>
			{children}
		</LadleHeatMetricContext.Provider>
	);
};
